import React, { useState } from 'react';
import * as S from './styles';
import local_bar from '../../../../assets/img/local_bar.svg';
import skillet from '../../../../assets/img/skillet.svg';

const TaxOptionCard = ({ data, isSelected, onSelect }) => {
	return (
		<S.Card
			$isSelected={isSelected}
			onClick={() => {
				onSelect(data.id)
			}}
			role="radio"
			aria-checked={isSelected}
		>
			<S.Content>
				<S.Title>
					<S.Icon src={data.icon || null} />
					{data.title}
				</S.Title>
				<S.Subtitle>{data.subtitle}</S.Subtitle>
				<S.DetailText>{data.details}</S.DetailText>
			</S.Content>
			<S.RadioIndicator $isSelected={isSelected} />
		</S.Card>
	);
};

const TaxSelectionModule = ({
	setIbsCbsSituacao,
	setIbsCbsClassificacao,
	ibsCbsSituacao,
	ibsCbsClassificacao,
	updateIbsCbsClassificacaoOptions
}) => {
	const taxOptions = [
		{
			id: 1,
			title: "Revenda, Industrializados e Alcoólicos",
			subtitle: "Itens prontos de fábrica e alcoólicos. Ex: Cerveja, refrigerantes, drinks, chocolate, balas, isqueiro.",
			details: "Situação 000 / Classificação 000001 (Tributação integral)",
			ibs_cbs_situacao_tributaria: "000",
			ibs_cbs_classificacao_tributaria: "000001",
			icon: local_bar
		},
		{
			id: 2,
			title: "Alimentos Preparados / Produção Própria",
			subtitle: "Feitos ou servidos pela sua cozinha. Ex: Pratos feitos, lanches, pizzas, sucos, sobremesas caseiras.",
			details: "Situação 200 / Classificação 200034 (Redução de 60%)",
			ibs_cbs_situacao_tributaria: "200",
			ibs_cbs_classificacao_tributaria: "200034",
			icon: skillet
		},
	];

	const taxOptionDefault = taxOptions.find(option => option.ibs_cbs_situacao_tributaria === ibsCbsSituacao && option.ibs_cbs_classificacao_tributaria === ibsCbsClassificacao);
	const [selectedTaxId, setSelectedTaxId] = useState(taxOptionDefault?.id || null);

	const handleSelection = (id) => {
		setSelectedTaxId(id);
		updateIbsCbsClassificacaoOptions(taxOptions.find(option => option.id === id).ibs_cbs_situacao_tributaria);
		setIbsCbsSituacao(taxOptions.find(option => option.id === id).ibs_cbs_situacao_tributaria);
		setIbsCbsClassificacao(taxOptions.find(option => option.id === id).ibs_cbs_classificacao_tributaria);
	};

	return (
		<S.Container>
			{taxOptions.map((option) => (
				<TaxOptionCard
					key={option.id}
					data={option}
					isSelected={selectedTaxId === option.id || taxOptionDefault?.id === option.id}
					onSelect={handleSelection}
				/>
			))}
		</S.Container>
	);
};

export default TaxSelectionModule;